import XMLIterator from '../../util/XMLIterator'

'use strict'

export default {

  type: "ext-link",
  tagName: "ext-link",
  /*
    Attributes
    assigning-authority Authority Responsible for an Identifier
    ext-link-type Type of External Link
    id Document Internal Identifier
    specific-use Specific Use
    xlink:actuate Actuating the Link
    xlink:href Href (Linking Mechanism)
    xlink:role Role of the Link
    xlink:show Showing the Link
    xlink:title Title of the Link
    xlink:type Type of Link
    xml:base Base
    xml:lang Language
    xmlns:xlink XLink Namespace Declaration

    Content
    (#PCDATA | email | ext-link | uri | inline-supplementary-material |
      related-article | related-object | hr | bold | fixed-case | italic |
      monospace | overline | overline-start | overline-end | roman | sans-serif
      | sc | strike | underline | underline-start | underline-end | ruby |
      alternatives | inline-graphic | private-char | chem-struct | inline-formula |
      tex-math | mml:math | abbrev | milestone-end | milestone-start | named-content |
      styled-content | fn | target | xref | sub | sup | x)*
  */

  export: function (node, el, converter) { // eslint-disable-line
    el.attr({
      'ext-link-type': 'uri',
      'xlink:href': node.attributes['xlink:href'],
      'xmlns:xlink': 'http://www.w3.org/1999/xlink'
    })

  },

  import: function (node, el, converter) {
    
    if (node.getChildren()) {
      let children = node.getChildren()
      let iterator = new XMLIterator(children)

      iterator.optional('italic', function (child) {
        node.italic = converter.convertElement(child).id
      })
    }
    
  }

}
